import React, {useEffect, useRef, useState} from "react";
import styles from "./preferences-country.module.css";
import texts from "../../assets/ContextProvider/textsLocalized.json";

const PreferencesCountry = ({selectedPreferences, setSelectedPreferences, handleCountryError}) => {
  const containerRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const [countryName, setCountryName] = useState("");
  const [isCountriesSelectDisabled, setIsCountriesSelectDisabled] = useState(false);
  const [countriesRenderedList, setCountriesRenderedList] = useState([]);
  const [countriesEnglishNameRendered, setCountriesEnglishNameRendered] = useState([]);
  const [countriesFilteredList, setCountriesFilteredList] = useState([]);
  const [isCountriesFilteredListShown, setIsCountriesFilteredListShown] = useState(false);


  const handleSearchCountry = (e) => {
    setCountryName(e.target.value.trimStart());

    const searchingWord = e.target.value.trim().toLowerCase();

    const tempCountriesFilteredList = Object.entries(texts.preferences["countries-list"])
      .filter(([key, value]) => {
        if (countriesRenderedList.includes(value)) return false;

        const countryLowerCase = value.toLowerCase();
        const fewWordsInCountryName = countryLowerCase.split(" ");

        if (searchingWord.includes(" ")) {
          return countryLowerCase.includes(searchingWord);
        }

        return fewWordsInCountryName.some(separatedWord => separatedWord.startsWith(searchingWord));
      })
      .sort((a, b) => a[1].localeCompare(b[1]));

    setCountriesFilteredList(tempCountriesFilteredList);
  };


  useEffect(() => {
    if (countryName.length >= 2) {
      setIsCountriesFilteredListShown(true);
    } else {
      setIsCountriesFilteredListShown(false);
    }
  }, [countryName]);


  const createCountriesRenderedList = (e) => {
    const target = e.target;
    setCountriesRenderedList(prev => [target.textContent, ...prev]);
    setCountriesEnglishNameRendered(prev => [target.dataset.countryEnglishName, ...prev]);
    setCountryName('');
  };


  const removeCountriesRenderedListItem = (index) => {
    const updatedArray = countriesRenderedList.filter((item, idx) => idx !== index);
    setCountriesRenderedList(updatedArray);

    const updatedCountriesEnglishNamesArray = countriesEnglishNameRendered.filter((item, idx) => idx !== index);
    setCountriesEnglishNameRendered(updatedCountriesEnglishNamesArray);
  };


  useEffect(() => {
    if (countriesRenderedList.length >= 4) {
      setIsCountriesSelectDisabled(true);
      setCountryName('');
    } else {
      setIsCountriesSelectDisabled(false);
    }
    setSelectedPreferences(prev => ({...prev, country: countriesEnglishNameRendered}))
  }, [countriesRenderedList]);


  useEffect(() => {
    if (countryName.length === 1 ||
      isCountriesFilteredListShown === true ||
      (countryName.length >= 2 && countriesFilteredList.length < 1)) {
      handleCountryError(true);
    } else {
      handleCountryError(false);
    }
  }, [countryName, countriesFilteredList, isCountriesFilteredListShown]);


  return (
    <>
      <div className={styles["preferences-country-title"]}>
        {texts.preferences["country-title"]}
        <div className={styles["preferences-country-counter-container"]}>
                  <span className={
                    `${styles["preferences-country-counter"]}
                     ${countriesRenderedList.length === 4 ?
                      `${styles["preferences-country-counter-limit"]}` : ''}
                  `}>
          {countriesRenderedList.length}/4
        </span>
        </div>
      </div>
      <div ref={containerRef}
           className={`
             ${styles["preferences-country-inner-container"]}
             ${isFocused ? `${styles["preferences-country-selected"]} ${styles["active"]}` : ""}`}>
        <input className={
          `${styles["preferences-country-input"]}
           ${isCountriesSelectDisabled ? `${styles["preferences-country-input-disabled"]}` : ''}`}
               type="text"
               placeholder={!isCountriesSelectDisabled ?
                 texts.preferences["country-placeholder"]
                 :
                 texts.preferences["country-placeholder-warning"]}
               value={countryName}
               onChange={handleSearchCountry}
               onFocus={() => setIsFocused(true)}
               onBlur={() => setIsFocused(false)}/>
        <div className={
          `${styles["filtered-countries-list"]}
           ${isCountriesFilteredListShown && countriesFilteredList.length > 0 ?
            `${styles["shown"]}` : ""}
            ${!isFocused ? `${styles["border-not-input-active"]}` : ""}`}>
          {countriesFilteredList.map((item, index) => (
            <div className={styles["filtered-countries-list-item"]}
                 key={index}
                 onClick={createCountriesRenderedList}
                 data-country-english-name={item[0]}>
              {item[1]}
            </div>
          ))}
        </div>
      </div>
      <p className={`
      ${styles['country-not-found']}
      ${countryName.length >= 2 && countriesFilteredList.length < 1 ?
        `${styles["visible"]}` : ''}`}>
        {texts.preferences["country-error"]}
      </p>
      <div className={styles["selected-countries-list"]}>
        {countriesRenderedList.map((item, index) => (
          <button className={styles["selected-countries-list-item"]}
                  key={index}
                  onClick={() => removeCountriesRenderedListItem(index)}>
            {item}
          </button>))}
      </div>
    </>
  )
}

export default PreferencesCountry;